import {Injectable} from '@angular/core';
import {LokijsService} from './database/lokijs.service';
import {LiveContractResourceService} from './database/resource/live-contract-resource.service';
import {RemoveTransportLinesFromReturnService} from './remove-transport-lines-from-return.service';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';

@Injectable({
    providedIn: 'root'
})
export class GetLiveDetailLinesForCustomerService {

    constructor(private loki: LokijsService,
                private liveContractsResource: LiveContractResourceService,
                private removeTransportLines: RemoveTransportLinesFromReturnService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames) {
    }

    async fetchLiveDetailLinesForCust(custId: number) {
        await this.loki.getCollection('livedetaillines').findAndRemove({custId: custId});
        const plus = await this.removeTransportLines.findTransportPlus();
        const depots = await this.loki.getCollection('depot').chain().data();
        for (const d of depots) {
            try {
                const data: any = await this.liveContractsResource.getLiveDetailLinesForCustomer(d.cod, custId);
                console.log(data);
                await this.loki.bulkUpsert('livedetaillines', '_id', data);
                await this.loki.getCollection('livedetaillines').findAndRemove({plu: {$in: plus}});
                this.stateManagerService.getCache(this.collectionsNames.LIVEDETAILLINES, this.loki.getCollection(this.collectionsNames.LIVEDETAILLINES).chain().data());
            } catch (e) {
                console.log(e);
            }
        }
    }
}
